import { useEffect, useState } from "react";
import { siteNav } from "@/mocks/movieData";

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6 h-16 md:h-[72px] flex items-center justify-between gap-3">
        <a href="#top" className="flex items-center gap-2 cursor-pointer shrink-0">
          <span
            className={`w-9 h-9 rounded-md flex items-center justify-center text-lg transition-colors ${
              scrolled ? "bg-primary-500 text-background-50" : "bg-primary-500 text-background-50"
            }`}
          >
            <i className="ri-movie-2-line" />
          </span>
          <span
            className={`font-heading font-bold text-base md:text-lg whitespace-nowrap transition-colors ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            嫂子的诱惑
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1 lg:gap-2">
          {siteNav.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className={`px-3 py-2 rounded-md text-sm whitespace-nowrap cursor-pointer transition-colors ${
                scrolled
                  ? "text-foreground-700 hover:text-primary-600 hover:bg-primary-50"
                  : "text-background-100 hover:text-background-50 hover:bg-background-50/10"
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#lines"
            className="hidden md:inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
          >
            <i className="ri-play-circle-line" /> 观看指引
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md text-xl cursor-pointer transition-colors ${
              scrolled ? "text-foreground-950 hover:bg-background-200" : "text-background-50 hover:bg-background-50/10"
            }`}
          >
            <i className={menuOpen ? "ri-close-line" : "ri-menu-line"} />
          </button>
        </div>
      </div>

      {menuOpen ? (
        <div className="md:hidden bg-background-50 border-b border-background-200 px-4 py-3">
          <nav className="grid grid-cols-2 gap-2">
            {siteNav.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={() => setMenuOpen(false)}
                className="px-3 py-2.5 rounded-md text-sm text-foreground-700 bg-background-100 hover:bg-primary-50 hover:text-primary-600 cursor-pointer transition-colors"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      ) : null}
    </header>
  );
}